export default "__VITE_ASSET__BVpS8h19__"